import { pick } from "lodash-es"
import React from "react"
import CustomTextArea from "../Atoms/CustomTextArea"
import StringInput from "../Atoms/StringInput"
import FormController, { withFormController } from "../Molecules/FormController"
import CustomAutoComplete from "../Organisms/map/CustomAutoComplete"
import LocationMap from "../Organisms/map/LocationMap"
import MapControl from "../Organisms/map/MapControl"
function MapAddress({
  onChange,
  value: address,
  path: mapPath,
  disabled,
  children,
}) {
  function handleChange(path, value) {
    const addressCopy = { ...address }
    addressCopy[path] = value
    onChange(mapPath, addressCopy)
  }

  function handleMapChange(center, newAddress) {
    const addressCopy = {
      id: address?.id,
      ...newAddress,
      latitude: center.lat,
      longitude: center.lng,
    }

    onChange(mapPath, addressCopy)
  }

  const center = {
    lat: address?.latitude ?? 21.3088,
    lng: address?.longitude ?? 79.6755,
  }

  const mapAddress = pick(address, [
    "state",
    "pincode",
    "village",
    "taluka",
    "district",
    "address",
  ])

  return (
    <>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-3">
          <FormController
            disabled={disabled}
            disableAll={true}
            source={mapAddress}
            onChange={handleChange}
          >
            <StringInput big={false} required label="Village" path="village" />
            <StringInput big={false} label="Taluka" path="taluka" />
            <StringInput big={false} label="District" path="district" />
            <StringInput big={false} label="State" path="state" />
            <StringInput big={false} label="Pincode" path="pincode" />
            <CustomTextArea rows={5} fill label="Address" path="address" />
          </FormController>
        </div>
        <div className="col-span-9">
          <LocationMap
            disabled={disabled}
            onChange={handleMapChange}
            center={center}
          >
            {disabled ? null : (
              <MapControl position="TOP_CENTER">
                <CustomAutoComplete
                  onChange={(_, value) => {
                    onChange(mapPath, { id: address?.id, ...value })
                  }}
                />
              </MapControl>
            )}
            {children}
          </LocationMap>
        </div>
      </div>
    </>
  )
}

export default withFormController(MapAddress)
